import React from "react";
import {
  FilterableCounts,
  FilterQuery,
} from "../../../../../../microservices/functions/src/types/product_catalog/catalog_api_types";
import { FilterChangeHandler } from "../../types";

type TopLevelFilterItemProps = {
  checked: boolean;
  onChange: FilterChangeHandler;
  filterName: keyof FilterQuery;
  filterLabel: string;
  filter: FilterQuery;
  productsCount: number;
};

const TopLevelFilterItem = ({
  checked,
  filter,
  filterLabel,
  filterName,
  onChange,
  productsCount,
}: TopLevelFilterItemProps): JSX.Element => (
  <li>
    <label>
      <input
        type="checkbox"
        checked={checked}
        onChange={() => {
          onChange({
            ...filter,
            [filterName]: !checked,
          });
        }}
      />
      <span>
        {filterLabel}
        <b>{` (${productsCount})`}</b>
      </span>
    </label>
  </li>
);

type BooleanFiltersControlsProps = {
  filter: FilterQuery;
  onChange: FilterChangeHandler;
  filterableCount: FilterableCounts;
};

export const BooleanFiltersControls = ({
  filter,
  filterableCount,
  onChange,
}: BooleanFiltersControlsProps) => (
  <fieldset>
    <ul>
      <TopLevelFilterItem
        checked={!!filter.available}
        onChange={onChange}
        filterName="available"
        filterLabel="Okamžité odeslání"
        filter={filter}
        productsCount={filterableCount.available}
      />
      <TopLevelFilterItem
        checked={!!filter.freeShipping}
        onChange={onChange}
        filterName="freeShipping"
        filterLabel="Doprava zdarma"
        filter={filter}
        productsCount={filterableCount.freeShipping}
      />
    </ul>
  </fieldset>
);
